
import Vue from "vue";
import { timeToStart } from "@/config/registrationWindow";

const startYear = new Date(timeToStart).getFullYear();
const academicYear = `${startYear}-${startYear + 1}`;

export default Vue.extend({
  name: "ConfirmTrustedDataDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data: () => ({
    model: false as boolean,
    logo: require("@/assets/images/usmf-logo.png"),
    checkboxes: [
      {
        type: 1,
        value: false,
        text: "În calitate de candidat, îmi asum întreaga responsabilitate pentru toate declarațiile făcute cu ocazia aplicării online la sesiunea de admitere a Universității",
      },
      {
        type: 2,
        value: false,
        text:
          "Declar pe propria răspundere că am luat cunoștință și am înțeles prevederile Regulamentului de organizare și desfășurare a admiterii la studii de rezidenţiat la Instituția\n" +
          "Publică Universitatea de Stat de Medicină şi Farmacie „Nicolae Testemiţanu” din Republica\n" +
          `Moldova în anul universitar ${academicYear}, afișat pe pagina web a Universității și confirm\n` +
          "faptul că toate informațiile pe care le furnizez în aplicația de înscriere online sunt reale",
      },
      {
        type: 3,
        value: false,
        text:
          "Am fost informat, am înțeles și accept că, la etapa de alegere a specialității, candidații sau\n" +
          "împuterniciții acestora, care nu sunt prezenți la data, ora și locul fixate pentru alegerea\n" +
          "specialității, postului/locului în specialitate, pierd drepturile conferite de concurs",
      },
      {
        type: 3,
        value: false,
        text:
          "Am fost informat, am înțeles și accept că orice candidat, care renunță la alegerea\n" +
          "specialității, unui post/loc, este declarat respins.",
      },
    ] as Array<any>,
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        // @ts-ignore
        this.model = this.value;
      },
    },
  },

  computed: {
    disabled() {
      return this.checkboxes.some((item: any) => !item.value);
    },
  },

  methods: {
    toggle() {
      this.model = !this.model;
    },
    confirmPrivacy() {
      this.$emit("submit");
      this.closeDialog();
    },
    closeDialog() {
      this.$emit("input", false);
    },
  },
});
